import { oz } from '@weft/utils';
import { PeriodSchema } from '../../../primitives';
import { CustomerRevenueReportItemSchema } from './customer-revenue-report-item-schema';

export const CustomerRevenueReportSchema = oz.object({
  accountId: oz.string(),
  reportPeriod: PeriodSchema,
  reportItems: CustomerRevenueReportItemSchema.array(),
});

export type CustomerRevenueReport = oz.infer<typeof CustomerRevenueReportSchema>;